module.exports = __webpack_public_path__ + "img/FanYong.409b6e2f.svg";